{
  "eyebrow": "Ești înăuntru",
  "title": "Bun venit la Done-it, {{company}}.",
  "sub": "Perioada de probă de 30 de zile pentru {{plan}} este activă. Trei pași următori.",
  "next1": {
    "title": "Descarcă aplicația mobilă",
    "desc": "Trimite-i echipei tale linkul de instalare prin SMS sau email.",
    "cta": "Trimite link de invitație"
  },
  "next2": {
    "title": "Invită-ți echipa",
    "desc": "Importă angajații în masă din CSV sau adaugă-i unul câte unul.",
    "cta": "Deschide administrarea"
  },
  "next3": {
    "title": "Urmărește un tur de 4 minute",
    "desc": "Vezi cum să configurezi primul proiect și locațiile.",
    "cta": "Vezi videoclipul"
  },
  "cta": "Mergi la panou",
  "receipt": "O chitanță și un email de bun venit sunt pe drum către {{email}}.",
  "fallbacks": {
    "company": "compania ta",
    "plan": "planul tău",
    "inbox": "căsuța ta de email"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Contul tău {{plan}} este activ — gratuit pentru totdeauna. Trei lucruri de făcut în continuare."
}
